import React from "react";
import WarehousesBK from "layouts/BK/warehouses";

function WarehousesCM() {
  return <WarehousesBK />;
}

export default WarehousesCM;
